var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5403 5.07431C10.7134 4.6699 11.2866 4.6699 11.4597 5.07431L13.4267 9.67129C13.4742 9.78227 13.5602 9.87232 13.6689 9.92482L18.0679 12.0498C18.4446 12.2317 18.4446 12.7683 18.0679 12.9502L13.6689 15.0752C13.5602 15.1277 13.4742 15.2177 13.4267 15.3287L11.4597 19.9257C11.2866 20.3301 10.7134 20.3301 10.5403 19.9257L8.57331 15.3287C8.52583 15.2177 8.4398 15.1277 8.33111 15.0752L3.93205 12.9502C3.55536 12.7683 3.55536 12.2317 3.93205 12.0498L8.33111 9.92482C8.4398 9.87232 8.52583 9.78227 8.57331 9.67129L10.5403 5.07431Z",
    fill: "#1778E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0448 2.00118C17.2225 1.61042 17.7775 1.61042 17.9552 2.00118L18.8289 3.92291C18.8789 4.03294 18.9671 4.12113 19.0771 4.17115L20.9988 5.04483C21.3896 5.22248 21.3896 5.77752 20.9988 5.95517L19.0771 6.82885C18.9671 6.87887 18.8789 6.96706 18.8289 7.07709L17.9552 8.99882C17.7775 9.38958 17.2225 9.38958 17.0448 8.99882L16.1711 7.07709C16.1211 6.96706 16.0329 6.87887 15.9229 6.82885L14.0012 5.95517C13.6104 5.77752 13.6104 5.22248 14.0012 5.04483L15.9229 4.17115C16.0329 4.12113 16.1211 4.03294 16.1711 3.92291L17.0448 2.00118Z",
    fill: "#EE6821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEmoji);
export default __webpack_public_path__ + "static/media/ai-emoji.c9ff00d2.svg";
export { ForwardRef as ReactComponent };